import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/platform-browser';
import {ApiConnectService} from 'app/services/api-connect.service';
import {UserService} from 'app/services/user.service';
import {growthImportRequestId} from './grade-growth-source-refresh';

const EMPTY_OWNER = '';
const ADMIN_ROLE = 'ROLE_ADMIN';
const ADMIN_AUTHORITY = 'ADMIN';
const SOURCE_REFRESH_PATH = '/common/admin/grade-growth/source-refresh/users/';
const PATH_SEPARATOR = '/';
const FIRST_ROLE = 0;

@Injectable()
export class GradeGrowthReadContext {
  constructor(private api: ApiConnectService, private users: UserService,
    @Inject(DOCUMENT) private browserDocument: Document) {}

  userUrl(userId: string): string { return this.api.getUserById + encodeURIComponent(userId); }

  sourceRefreshUrl(userId: string): string {
    return this.api.baseApiUrl + SOURCE_REFRESH_PATH + encodeURIComponent(userId) + PATH_SEPARATOR;
  }

  sourceRequestId(): string { return growthImportRequestId(this.browserDocument.defaultView.crypto); }

  canRefreshSource(): boolean {
    const user = this.users.getLocal();
    return !!user && !!user.roles && (user.roles.indexOf(ADMIN_ROLE) >= FIRST_ROLE
      || user.roles.indexOf(ADMIN_AUTHORITY) >= FIRST_ROLE);
  }

  owner(): string {
    const user = this.users.getLocal();
    return user && user.id ? JSON.stringify([user.id, (user.roles || []).slice().sort()]) : EMPTY_OWNER;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/grade-growth/grade-growth-read-context.ts